import React from 'react';
import PropTypes from 'prop-types';

const getLabel = (name) => {
  switch (name) {
    case 'EV1pico2':
    case 'EV1mr':
    case 'EV1hr': return 'EV1';
    case 'EV2pico2':
    case 'EV2mr':
    case 'EV2hr': return 'EV2';
    default: return '';
  }
};

const getUnit = (name) => {
  switch (name) {
    case 'EV1pico2':
    case 'EV2pico2': return 'mmHg';
    case 'EV1mr':
    case 'EV2mr': return 'BTU/HR';
    case 'EV1hr':
    case 'EV2hr': return 'BPM';
    default: return '';
  }
};

const MetRateTooltip = ({ active, payload }) => {
  if (!active) {
    return null;
  }
  const [firstPayload] = payload || [];
  const { payload: data } = firstPayload || {};
  const { formattedTimestamp } = data || {};
  return (
    <ul className="custom-tooltip">
      {
        (payload || []).sort((a, b) => (a.name > b.name ? 1 : -1)).map(({ name, value, color }) => (
          <li className="label" style={{ color }} key={value}>
            {
              Number.isNaN(value) || value === 'NaN' ? null : `${getLabel(name)}: ${value} ${getUnit(name)}`
            }
          </li>
        ))
      }
      {
        formattedTimestamp ? <li className="label">{`Time: ${formattedTimestamp}`}</li> : null
      }
    </ul>
  );
};

MetRateTooltip.propTypes = {
  active: PropTypes.any,
  payload: PropTypes.any,
};

export default MetRateTooltip;
